module.exports = __webpack_public_path__ + "static/media/icon-refresh-type01.60e4e821.svg";